import { Group as MantineGroup, GroupProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedGroupProps extends GroupProps {
  spaceBetween?: boolean;
  centered?: boolean;
  fullWidth?: boolean;
}

const Group = forwardRef<HTMLDivElement, ThemedGroupProps>(
  ({ spaceBetween = false, centered = false, fullWidth = false, justify, align, style, children, ...rest }, ref) => {
    const computedJustify = spaceBetween ? 'space-between' : centered ? 'center' : justify;
    const computedAlign = centered ? 'center' : align;

    return (
      <MantineGroup
        ref={ref}
        justify={computedJustify}
        align={computedAlign}
        style={{
          width: fullWidth ? '100%' : undefined,
          ...style,
        }}
        {...rest}
      >
        {children}
      </MantineGroup>
    );
  }
);

Group.displayName = 'Group';

export default Group;
